/**
 * Promotions API – mirrors src/services/promotions.ts and routes/promotions.ts
 * in vin-pulse-os-api. Read-only from the ecommerce app (Customer role may
 * only GET active promotions).
 *
 * Used by the catalog's "Deals" quick filter (VP-CUST-002) — a SKU is
 * considered a deal when an active promotion's scope matches it.
 */

import { apiClient } from './apiClient';

export type DiscountType = 'percent' | 'flat';
export type PromotionScope = 'all' | 'category' | 'sku';

export interface Promotion {
  id: number;
  name: string;
  description: string | null;
  discount_type: DiscountType;
  discount_value: number;
  scope: PromotionScope;
  category_id: number | null;
  category_name: string | null;
  sku_id: number | null;
  sku_code: string | null;
  starts_at: string;
  ends_at: string;
  is_active: boolean;
  created_by_user_id: number;
  created_at: string;
  updated_at: string;
}

export async function listPromotions(): Promise<Promotion[]> {
  // The route wraps as `{ data: [...] }` without a `success` envelope, so
  // apiClient.get doesn't unwrap further (same shape as /categories).
  const raw = await apiClient.get<Promotion[] | { data: Promotion[] }>('/promotions');
  if (Array.isArray(raw)) return raw;
  return raw?.data ?? [];
}
